﻿export class CustomerConstant {
    static defaultCountryId = 237;
    static fuseProductSeName = "dc-fuses-and-disconnects";
    static powerProductSeName = "dc-power-distribution";
    static allProductsViewName = 'all';

    static nominalVoltageId = 16;
    static maxFuseId = 22;
    static numberOfPositionId = 21;
    static numberOfBusesId = 18;
    static busRatingId = 19;
    static inputTypeId = 29;
    static outputTypeId = 32;
    static rackSpacesId = 11;
    static mountingId = 9;
}